import { Maximize2, Minimize2 } from "lucide-react"
import { Trigger } from "@/components/design-system"
import { toggleFullscreen } from "@/hooks/useFullscreen"
import { useUIStore } from "@/stores/uiStore"

export function FullscreenTrigger() {
  const isFullscreen = useUIStore((s) => s.isFullscreen)

  return (
    <Trigger
      id="fullscreen-btn"
      icon={isFullscreen
        ? <Minimize2 className="h-3.5 w-3.5" strokeWidth={1.5} />
        : <Maximize2 className="h-3.5 w-3.5" strokeWidth={1.5} />
      }
      label={isFullscreen ? "Exit fullscreen" : "Fullscreen"}
      tooltip={<>{isFullscreen ? "Exit fullscreen" : "Fullscreen"} <kbd style={{ fontFamily: "var(--font-mono)", fontSize: 9 }}>⇧F</kbd></>}
      active={isFullscreen}
      onClick={toggleFullscreen}
      size="sm"
    />
  )
}
